(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sanava-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (customElements.get('sanava-faq')) return;

  class SanavaFaq extends HTMLElement {
    connectedCallback() {
      this.panels = Array.from(this.querySelectorAll('[data-sfaq-panel]'));
      this.tabs = Array.from(this.querySelectorAll('[data-sfaq-tab]'));
      this.items = Array.from(this.querySelectorAll('[data-sfaq-item]'));
      this.tablist = this.querySelector('[data-sfaq-tablist]');
      this.tabsWrap = this.querySelector('[data-sfaq-tabs-wrap]');
      this.popular = this.querySelector('[data-sfaq-popular]');
      this.input = this.querySelector('[data-sfaq-search]');
      this.empty = this.querySelector('[data-sfaq-empty]');
      this.singleOpen = this.hasAttribute('data-single-open');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.hasTabs = this.tabs.length > 1;
      if (this.hasTabs) this.classList.add('is-ready');

      this.items.forEach((item) => {
        item._text = this.norm(item.textContent);
        item.querySelector('summary').addEventListener('click', (e) => {
          e.preventDefault();
          this.toggle(item, !this.isOpen(item));
        });
      });

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (e) => {
          e.preventDefault();
          this.activate(tab.getAttribute('aria-controls'), true);
        });
      });
      if (this.tablist) {
        this.tablist.addEventListener('keydown', (e) => this.onTabKey(e));
        this.tablist.addEventListener('scroll', () => this.updateFade(), { passive: true });
      }

      this.querySelectorAll('[data-sfaq-jump]').forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.jumpTo(link.getAttribute('href').slice(1));
        });
      });

      if (this.input) {
        this.input.addEventListener('input', () => this.filter(this.input.value));
        const form = this.input.closest('form');
        if (form) form.addEventListener('submit', (e) => e.preventDefault());
      }

      if (!this.fromHash()) {
        const start = this.panels.find((p) => p.classList.contains('is-active')) || this.panels.find((p) => !p.hasAttribute('data-static'));
        if (start) this.activate(start.id, false);
      }
      this.updateFade();

      this._onHash = () => this.fromHash();
      this._onResize = () => this.updateFade();
      this._onSelect = (e) => this.onEditorSelect(e);
      window.addEventListener('hashchange', this._onHash);
      window.addEventListener('resize', this._onResize);
      document.addEventListener('shopify:block:select', this._onSelect);
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this._onHash);
      window.removeEventListener('resize', this._onResize);
      document.removeEventListener('shopify:block:select', this._onSelect);
    }

    byId(id) {
      if (!id) return null;
      try { return this.querySelector('#' + CSS.escape(decodeURIComponent(id))); } catch (e) { return null; }
    }

    norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim();
    }

    /* Tabs */
    activate(panelId, updateHash) {
      if (!this.hasTabs) return;
      const panel = this.byId(panelId);
      if (!panel || panel.hasAttribute('data-static')) return;
      this.panels.forEach((p) => { if (!p.hasAttribute('data-static')) p.classList.toggle('is-active', p === panel); });
      this.tabs.forEach((t) => {
        const on = t.getAttribute('aria-controls') === panelId;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on) this.revealTab(t);
      });
      if (updateHash) history.replaceState(null, '', '#' + panelId);
    }

    onTabKey(e) {
      const i = this.tabs.indexOf(document.activeElement);
      if (i < 0) return;
      const last = this.tabs.length - 1;
      let n = null;
      if (e.key === 'ArrowRight') n = i === last ? 0 : i + 1;
      else if (e.key === 'ArrowLeft') n = i === 0 ? last : i - 1;
      else if (e.key === 'Home') n = 0;
      else if (e.key === 'End') n = last;
      if (n === null) return;
      e.preventDefault();
      this.activate(this.tabs[n].getAttribute('aria-controls'), true);
      this.tabs[n].focus();
    }

    revealTab(tab) {
      const list = this.tablist;
      if (!list || list.scrollWidth <= list.clientWidth) return;
      list.scrollTo({ left: Math.max(0, tab.offsetLeft - 20), behavior: this.reduced ? 'auto' : 'smooth' });
    }

    updateFade() {
      if (!this.tablist || !this.tabsWrap) return;
      const max = this.tablist.scrollWidth - this.tablist.clientWidth;
      this.tabsWrap.classList.toggle('has-more', max > 4 && this.tablist.scrollLeft < max - 4);
    }

    /* Deep links, Most asked and the theme editor */
    jumpTo(id, instant) {
      const el = this.byId(id);
      if (!el) return;
      if (this.input && this.input.value) { this.input.value = ''; this.filter(''); }
      const panel = el.closest('[data-sfaq-panel]');
      if (panel) this.activate(panel.id, false);
      if (el.matches('[data-sfaq-item]')) this.toggle(el, true, true);
      history.replaceState(null, '', '#' + id);
      requestAnimationFrame(() => el.scrollIntoView({ behavior: instant || this.reduced ? 'auto' : 'smooth', block: 'start' }));
    }

    fromHash() {
      const id = location.hash.slice(1);
      const el = this.byId(id);
      if (!el) return false;
      if (el.matches('[data-sfaq-panel]')) { this.activate(el.id, false); return true; }
      if (el.matches('[data-sfaq-item]')) { this.jumpTo(id, true); return true; }
      return false;
    }

    onEditorSelect(e) {
      const target = e.target;
      if (!target || !this.contains(target)) return;
      if (target.matches('[data-sfaq-panel]')) this.activate(target.id, false);
      if (target.matches('[data-sfaq-item]')) {
        const panel = target.closest('[data-sfaq-panel]');
        if (panel) this.activate(panel.id, false);
        this.toggle(target, true, true);
      }
    }

    /* Accordion */
    isOpen(item) {
      return item.open && !item.classList.contains('is-closing');
    }

    toggle(item, open, instant) {
      if (open === this.isOpen(item)) return;
      const panel = item.querySelector('.sfaq__a');
      if (item._anim) { item._anim.cancel(); item._anim = null; item.classList.remove('is-closing'); }
      if (open && this.singleOpen) {
        this.items.forEach((other) => { if (other !== item && this.isOpen(other)) this.toggle(other, false, instant); });
      }
      if (instant || this.reduced || !panel.animate) { item.open = open; return; }
      if (open) {
        item.open = true;
        const h = panel.scrollHeight;
        item._anim = panel.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 340, easing: 'cubic-bezier(.2,.7,.2,1)' });
        item._anim.onfinish = () => { item._anim = null; };
      } else {
        const h = panel.scrollHeight;
        item.classList.add('is-closing');
        item._anim = panel.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 260, easing: 'ease' });
        item._anim.onfinish = () => { item.open = false; item.classList.remove('is-closing'); item._anim = null; };
      }
    }

    /* Search across every topic */
    filter(query) {
      const terms = this.norm(query).split(' ').filter(Boolean);
      const searching = terms.length > 0;
      const matched = [];
      this.items.forEach((item) => {
        const ok = !searching || terms.every((t) => item._text.indexOf(t) !== -1);
        item.hidden = !ok;
        if (ok && searching) matched.push(item);
      });
      this.panels.forEach((p) => { p.hidden = searching && !p.querySelector('[data-sfaq-item]:not([hidden])'); });
      this.classList.toggle('is-searching', searching);
      if (this.popular) this.popular.hidden = searching;
      if (this.tabsWrap) this.tabsWrap.hidden = searching;
      if (this.empty) this.empty.hidden = !searching || matched.length > 0;
      if (searching && matched.length <= 3) matched.forEach((i) => this.toggle(i, true, true));
      if (!searching) this.updateFade();
    }
  }

  customElements.define('sanava-faq', SanavaFaq);
})();

  } catch(e) { console.error(e); }
})();
})();
